import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TableColType } from '@shared/enums/table.enum';
import { IReference } from '@shared/interfaces/reference.interface';
import { ITableCol } from '@shared/interfaces/table.col.interface';
import { ITextActivity } from '@shared/interfaces/text-activity.interface';
import { LoggerService } from '@shared/services/logger.service';
import { ReferencesService } from '@shared/services/references.service';

@Component({
    selector: 'app-sidebar-reference-texts',
    templateUrl: './sidebar.reference.texts.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarReferenceTextsComponent implements OnInit {
  @Input() public reference: IReference;

  public isLoading = Boolean(true);

  public rows: ITextActivity[] = [];
  public cols: Partial<ITableCol>[] = [
    {
      headerText: 'TABLES.HEADERS.STATUS',
      type: TableColType.Icon,
      cellClassName: 'text-capitalize',
      selector: 'label'
    },
    {
      headerText: 'TABLES.HEADERS.PHONE_NUMBER',
      type: TableColType.Text,
      selector: 'phone_number'
    },
    {
      headerText: 'TABLES.HEADERS.DESCRIPTION',
      cellClassName: 'text-wrap',
      type: TableColType.Text,
      selector: 'error_message',
      selectorFunction: (data: string) => data || '-'
    },
    {
      headerText: 'TABLES.HEADERS.BODY',
      type: TableColType.Text,
      selector: 'body'
    },
    {
      headerText: 'TABLES.HEADERS.FROM',
      type: TableColType.Text,
      selector: 'from'
    },
    {
      headerText: 'TABLES.HEADERS.DATE',
      type: TableColType.Ago,
      selector: 'created_at'
    }
  ];

  private readonly constructorName: string = String(this.constructor.name);

  constructor(
    private readonly _logger: LoggerService,
    private readonly _references: ReferencesService
  ) {}

  ngOnInit(): void {
    this.getTextActivity();
  }

  public getTextActivity() {
    const phone = this.reference.phone;

    if (!!phone) {
      const url = `GET /references/${this.reference.id}/text_activities`;
      this._references.getReferenceTextActivities(this.reference.id).subscribe(
        (res: ITextActivity[]) => {
          this._logger.info(this.constructorName, url, res);

          this.rows = res;
          this.isLoading = false;
        },
        (err: any) => {
          this._logger.error(this.constructorName, url, err);

          this.isLoading = false;
        }
      );
    } else {
      this.isLoading = false;
    }
  }

  public trackByFn(i: ITextActivity): string {
    return i.id;
  }
}
